let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dK7gM")).then(() => parcelRequire('9Od2Z'));